import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import Button from "react-bootstrap/Button";
import { obtenerArchivos, descargarArchivo } from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const Barker = () => {
    const [videos, setVideos] = useState([]); // Estado para almacenar los videos
    const seccionId = 17;  // ID correspondiente a la sección de Barker

    useEffect(() => {
        const cargarVideos = async () => {
            const response = await obtenerArchivos({ seccionId });

            if (response && response.success) {
                const archivos = response.archivos
                    .filter(archivo => archivo.tipo_mime.includes("video")) // Filtrar solo videos
                    .map(archivo => {
                        // Procesar el nombre para obtener un título formateado con la fecha
                        const parts = archivo.nombre_completo.split("_");
                        let displayTitle = archivo.nombre_archivo; // Valor por defecto
                        if (parts.length >= 3) {
                            const timestamp = parseInt(parts[1], 10);
                            // Convertir el timestamp (en segundos) a milisegundos y crear el objeto Date
                            const date = new Date(timestamp * 1000);
                            // Nombres de los meses en español
                            const monthNames = [
                                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                            ];
                            const month = monthNames[date.getMonth()];
                            const year = date.getFullYear();
                            displayTitle = `${month} ${year}`;
                        }
                        return {
                            url: archivo.ruta_archivo,          // URL del video
                            title: displayTitle,                  // Título formateado para mostrar
                            originalName: archivo.nombre_archivo, // Nombre original para la descarga
                        };
                    });

                setVideos(archivos);
            }
        };

        cargarVideos();
    }, [seccionId]);

    return (
        <section style={{ paddingTop: "120px" }}>
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1 className="banner-title text-center">Barker</h1>
                </div>

                {/* Mostrar el nombre (fecha formateada) encima del video */}
                {videos.length > 0 && (
                    <div className="text-center mb-3">
                        <h2 className="text-black text-center">{videos[0].title}</h2>
                    </div>
                )}

                <div className="d-flex justify-content-center">
                    {videos.length > 0 ? (
                        <ReactPlayer
                            url={videos[0].url} // Se muestra el primer video disponible
                            controls
                            width="100%"
                            height="480px"
                        />
                    ) : (
                        <p className="text-center text-white">No hay videos disponibles.</p>
                    )}
                </div>

                <div className="d-flex justify-content-center mt-4">
                    <Button
                        className="button_id me-2"
                        onClick={() => descargarArchivo(seccionId, videos[0].originalName)}
                        disabled={videos.length === 0}
                    >
                        Descargar
                        <i className="bi bi-download ms-2"></i>
                    </Button>
                </div>
            </Container>
        </section>
    );
};
